import React from "react";
import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

function Paginat({ pagination, onPageChange, className }) {
  if (!pagination) return null;

  const { current_page, last_page, prev_page_url, next_page_url } = pagination;

  const getPageNumbers = () => {
    const totalPagesToShow = 5;
    let startPage, endPage;

    if (last_page <= totalPagesToShow) {
      startPage = 1;
      endPage = last_page;
    } else {
      if (current_page <= 3) {
        startPage = 1;
        endPage = 5;
      } else if (current_page + 2 >= last_page) {
        startPage = last_page - 4;
        endPage = last_page;
      } else {
        startPage = current_page - 2;
        endPage = current_page + 2;
      }
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <Pagination className={`text-white flex justify-end items-end ${className}`}>
      <PaginationContent>
        {/* Previous Button */}
        <PaginationItem>
          <PaginationPrevious
            className={`hover:bg-cyellow ${
              !prev_page_url ? "opacity-50 cursor-not-allowed" : ""
            } h-7 w-7`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (prev_page_url) onPageChange(current_page - 1);
            }}
            disabled={!prev_page_url}
          />
        </PaginationItem>

        {/* Show Ellipsis before */}
        {current_page > 3 && last_page > 5 && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}

        {/* Page Numbers */}
        {pageNumbers.map((page) => (
          <PaginationItem key={page}>
            <PaginationLink
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onPageChange(page);
              }}
              className={`${
                page === current_page
                  ? "bg-cyellow text-black border-0"
                  : "border border-gray-600"
              } hover:bg-cyellow h-7 w-7`}
              isActive={page === current_page}
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}

        {/* Show Ellipsis after */}
        {current_page < last_page - 2 && last_page > 5 && (
          <PaginationItem>
            <PaginationEllipsis />
          </PaginationItem>
        )}

        {/* Next Button */}
        <PaginationItem>
          <PaginationNext
            className={`hover:bg-cyellow ${
              !next_page_url ? "opacity-50 cursor-not-allowed" : ""
            } h-7 w-7`}
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (next_page_url) onPageChange(current_page + 1);
            }}
            disabled={!next_page_url}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}

export default Paginat;
